import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import Pulse from "react-reveal/Pulse";

import "./mobileNavBar.scss";

import logo from "../../assets/images/logo.svg";
import ic_menu from "../../assets/images/mobileNavBar/menu.svg";
import ic_close from "../../assets/images/mobileNavBar/close.svg";
import user from "../../assets/images/user.svg";

function MobileNavBar(props) {
    const [productsToggle, setProductsToggle] = useState(false);
    const [showNavbar, setShowNavbar] = useState(false);

    return (
        <div className="MobileNavBar">
            {!showNavbar ? (
                <div className="navbar-header container">
                    <a
                        className="navbar-brand"
                        href="/"
                    >
                        <Pulse>
                            <img src={logo} className="navbar-brand-img" alt="alif logo"/>
                        </Pulse>
                    </a>
                    <button
                        onClick={() => setShowNavbar(!showNavbar)}
                        className="show-navbar-button float-right"
                    >
                        <img src={ic_menu} alt="menu"/>
                    </button>
                </div>
            ) : (
                <nav className="navbar navbar-light container">
                    <button
                        className="navbar-toggler"
                        onClick={() => setProductsToggle(!productsToggle)}
                        type="button"
                        data-toggle="collapse"
                        data-target="#mobileNavbarContent"
                        aria-controls="mobileNavbarContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        Все продукты{" "}
                        <i className={!productsToggle ? "fa fa-angle-up" : "fa fa-angle-down"}></i>
                    </button>
                    <button
                        onClick={() => setShowNavbar(!showNavbar)}
                        className="show-navbar-button float-right"
                    >
                        <img src={ic_close} alt="menu"/>
                    </button>

                    <div
                        className="collapse navbar-collapse navbar-toggleable-lg show"
                        id="mobileNavbarContent"
                    >
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link" href="https://alif.shop">
                                    alif.shop
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://intiqol.tj">
                                    Переводы
                                </a>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" activeClassName="active" to="/deposit">Депозиты</NavLink>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://km.alif.mobi">
                                    Карты
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://auto.alif.tj">
                                    Автокредит
                                </a>
                            </li>
                            <li className="nav-item">
                                <NavLink className="active-nav-link" to="/">
                                    Салом
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://alifmobi.tj/">
                                    alif mobi
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://alif.academy">
                                    Академия
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://job.alif.tj">
                                    Вакансии
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://alifpay.tj">
                                    alif pay
                                </a>
                            </li>
                            <li className="nav-item pt-2">
                                <a className="nav-link action-link" href="https://online.alif.tj">
                                    <img src={user} alt="user-icon"/> Вход
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            )}
        </div>
    );
}


export default MobileNavBar;
